import { render, staticRenderFns } from "./BigPowerSwitcher.vue?vue&type=template&id=63b55fb5&scoped=true"
import script from "./BigPowerSwitcher.vue?vue&type=script&lang=js"
export * from "./BigPowerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BigPowerSwitcher.vue?vue&type=style&index=0&id=63b55fb5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b55fb5",
  null
  
)

export default component.exports